import React from "react";
import { useAuth } from "../../context/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Avatar } from "antd";
import { BadgeCheck, LogOut } from "lucide-react";
import { useSidebar } from "../ui/sidebar";
import { cn } from "../../lib/utils";
import { UrlImage } from "../../lib/api";
import { useNavigate } from "react-router-dom";

export default function NavUser() {
  const { user, logout, loading } = useAuth();
  const { isMobile } = useSidebar();
  const navigate = useNavigate();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button variant="ghost" className="outline-none">
          <Avatar
            className={cn(
              "w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium",
              "bg-blue-100 text-blue-600",
              "dark:bg-blue-900 dark:text-blue-300"
            )}
            src={`${UrlImage}${user?.image}`}
          >
            {user?.name?.substring(0, 2).toUpperCase()}
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
        // side={isMobile ? "bottom" : "right"}
        // align="end"
        sideOffset={4}
      >
        <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <Avatar
              className={cn(
                "w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium",
                "bg-blue-100 text-blue-600",
                "dark:bg-blue-900 dark:text-blue-300"
              )}
              src={`${UrlImage}${user?.image}`}
            >
              {user?.name?.substring(0, 2).toUpperCase()}
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">{user?.name}</span>
              <span className="truncate text-xs">{user?.email}</span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            onClick={() => navigate(`/users-profile/${user?.bid}`)}
          >
            <BadgeCheck />
            Account
          </DropdownMenuItem>
        </DropdownMenuGroup>
        {!loading && user?.role === "admin" && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout}>
              <LogOut />
              Log out
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
